// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__-AeS7","requiredAsterisk":"Info_requiredAsterisk__2NqIm"};